import { createAction, props } from '@ngrx/store';
import { EnergyStarAccount, CreateEnergyStarAccountRequest, UpdateEnergyStarAccountRequest } from '../../model/energy-star-account.model';

export const loadEnergyStarAccounts = createAction('[Energy Star Account] Load Energy Star Accounts');
export const loadEnergyStarAccountsSuccess = createAction(
  '[Energy Star Account] Load Energy Star Accounts Success',
  props<{ accounts: EnergyStarAccount[] }>(),
);
export const loadEnergyStarAccountsFailure = createAction('[Energy Star Account] Load Energy Star Accounts Failure', props<{ error: any }>());

export const createEnergyStarAccount = createAction('[Energy Star Account] Create Energy Star Account', props<{ request: CreateEnergyStarAccountRequest }>());
export const createEnergyStarAccountSuccess = createAction('[Energy Star Account] Create Energy Star Account Success', props<{ account: EnergyStarAccount }>());
export const createEnergyStarAccountFailure = createAction(
  '[Energy Star Account] Create Energy Star Account Failure',
  props<{ error: any; errorMessage: string }>(),
);

export const updateEnergyStarAccount = createAction(
  '[Energy Star Account] Update Energy Star Account',
  props<{ id: number; request: UpdateEnergyStarAccountRequest }>(),
);
export const updateEnergyStarAccountSuccess = createAction('[Energy Star Account] Update Energy Star Account Success', props<{ account: EnergyStarAccount }>());
export const updateEnergyStarAccountFailure = createAction('[Energy Star Account] Update Energy Star Account Failure', props<{ error: any }>());
